import Input from './Input.react';

class InputPhone extends React.Component {

    render() {
        var self = this,
            value = this.props.value || '',
            type = this.props.type || 'text',
            id   = this.props.id || uuid(),
            className = this.props.className || '',
            tabindex = this.props.tabindex || '';

        value = value.replace(/[^0-9]/g, '');

        if (value.length === 3)
            value = '('+value;
        else if (value.length >= 4 && value.length <= 6)
            value = '('+value.substr(0, 3)+') '+value.substr(3, value.length-1);
        else if (value.length >= 7 && value.length <= 10)
            value = '('+value.substr(0, 3)+') '+value.substr(3, 3)+'-'+value.substr(6, value.length-1);

        return (
            <Input
                type={type}
                value={value}
                className={'input '+className}
                id={id}
                onChange={val => {
                    if (val.replace(/[^0-9]/g, '').length > 10)
                        return;

                    this.props.onChange(val.replace(/[^0-9]/g, ''));
                }}
                placeholder={this.props.placeHolder}
                tabindex={tabindex} />
        );
    }
}

export default InputPhone;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/input/InputPhone.react.jsx